import { DateTime } from 'luxon';

export function isAfterDateTime(dateA: Date, dateB: Date, allowEqual = false): boolean {
  const luxonDateA = DateTime.fromJSDate(dateA);
  const luxonDateB = DateTime.fromJSDate(dateB);

  const isAfter = luxonDateA > luxonDateB;

  return allowEqual ? isAfter || luxonDateA.equals(luxonDateB) : isAfter;
}
